import React from 'react';
import ReactDOM from 'react-dom';
import schema from './uec/schema';
import { ThemeProvider } from '@emotion/react';
import themes from './themes';
import Validation from './uec/formValidation';
import View from './uec/view';
const UecForm = Validation(schema)(View);

window.renderUEC = (id, props) => {
	const root = document.getElementById(id);
	const theme = themes[window.__UEC_THEME__ || 'aktualne'];
	ReactDOM.render(
		<ThemeProvider theme={theme}>
			<UecForm {...props} scrollTo={root} />
		</ThemeProvider>,
		root,
	);
};
